<!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: Shared
    Reason: navItem „Abrechnungen“ — the stored final statements of the agent as a widget table
            with Download and „Neu ausstellen“ (ACTIVE only). The widget stays mounted in every
            state (loading / empty / error only hide it), so it is created once and reloaded in place.
            „Empty“ comes from the unfiltered data only — a filter without hits keeps the table
            (and its filter) visible and shows the widget's own noDataText.
-->
<div class="block w-full">

    @if (!initialized) {

        <p-skeleton height="16rem"></p-skeleton>

    } @else if (!provisionAgentId) {

        <p-message severity="info" text="Kein Abrechnungskonto ausgewählt." styleClass="w-full"></p-message>

    } @else {

        @if (loading) {
            <p-skeleton height="16rem"></p-skeleton>
        } @else if (loadFailed) {
            <div class="flex align-items-center justify-content-between gap-2 mb-2">
                <p-message severity="error" styleClass="w-full"
                           text="Die Abrechnungen konnten nicht geladen werden.">
                </p-message>
                <p-button icon="fa-regular fa-arrows-rotate" severity="secondary" [text]="true" [rounded]="true"
                          pTooltip="Erneut laden" tooltipPosition="left" (onClick)="refresh()">
                </p-button>
            </div>
        } @else if (showEmptyState) {
            <div class="flex flex-column align-items-center justify-content-center gap-2 p-5 text-center">
                <i class="fa-regular fa-file-invoice text-4xl text-400"></i>
                <span class="text-700 font-medium">Noch keine Abrechnungen</span>
                <span class="text-500 text-sm">
                    Finale Provisionsabrechnungen entstehen nach der Auszahlung eines Provisionslaufs.
                </span>
            </div>
        }

        @if (statementsWidget) {
            <div [class.hidden]="widgetHidden">
                <mvs-widget #statementsWidgetRef [widgetData]="statementsWidget"
                            (onLoadData)="handleLoadData($event)">

                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns" [fieldId]="statusFieldId" label="Status">
                        <p-tag [value]="statusLabelOf(object)" [severity]="statusSeverityOf(object)"></p-tag>
                    </ng-template>

                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns" [fieldId]="actionsFieldId" label="Aktionen">
                        <div class="flex align-items-center gap-1">
                            @if (hasDocument(object)) {
                                <p-button icon="fa-regular fa-file-arrow-down"
                                          severity="secondary" [text]="true" [rounded]="true" size="small"
                                          pTooltip="Abrechnung herunterladen" tooltipPosition="left"
                                          [loading]="isDownloadBusy(object)"
                                          [disabled]="isDownloadBusy(object)"
                                          (onClick)="download(object)">
                                </p-button>
                            }
                            @if (isActive(object)) {
                                <p-button icon="fa-regular fa-file-pen"
                                          severity="secondary" [text]="true" [rounded]="true" size="small"
                                          [pTooltip]="canReissue
                                              ? 'Neu ausstellen'
                                              : 'Ihnen fehlt die Berechtigung, Provisionsabrechnungen neu auszustellen (cp_agentStatement).'"
                                          tooltipPosition="left"
                                          [disabled]="!canReissue"
                                          (onClick)="requestReissue(object)">
                                </p-button>
                            }
                        </div>
                    </ng-template>

                </mvs-widget>
            </div>
        }

    }

</div>
